module.exports = __webpack_public_path__ + "img/stvrt-mapa.b1b53cac.jpg";